import React from "react";
import styles from "./ganttTable.module.scss";

const GanttTable = () => {
  return <div className={styles.container}>GanttTable</div>;
};

export default GanttTable;
